import { createAsyncThunk } from '@reduxjs/toolkit'
import { LoanCalculatorSequenceServerData, AutoLoanAttributes } from '@lk/api'
import { translate } from 'loankeeper-common/helpers'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'

export const generateLoanCalculatorHash = createAsyncThunk<LoanCalculatorSequenceServerData, void, ThunkApi>(
  '[LOAN_CALCULATOR] GENERATE_HASH',
  async (_, { extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.sequence()

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to generate hash')
  },
)

export const calculateAutoLoan = createAsyncThunk<LoanCalculatorSequenceServerData, AutoLoanAttributes, ThunkApi>(
  '[LOAN_CALCULATOR] CALCULATE_AUTO_LOAN',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.auto(attributes)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to calculate auto loan')
  },
)

export const loadLoanCalculatorLookups = createAsyncThunk<any, void, ThunkApi>(
  '[LOAN_CALCULATOR] CALCULATE_AUTO_LOAN',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.lookups()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to load loan calculator lookups')
  },
)

export const addLoanCalculation = createAsyncThunk<any, any, ThunkApi>(
  '[LOAN_CALCULATOR] ADD',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.add(attributes)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message || translate('LKMESSAGE-HINT_ERR_TITLE')))

    return rejectWithValue('Failed to add loan calculation')
  },
)

export const deleteLoanCalculation = createAsyncThunk<any, any, ThunkApi>(
  '[LOAN_CALCULATOR] DELETE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.delete(attributes)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message || translate('LKMESSAGE-HINT_ERR_TITLE')))

    return rejectWithValue('Failed to delete loan calculation')
  },
)

export const printLoanCalculator = createAsyncThunk<any, any, ThunkApi>(
  '[LOAN_CALCULATOR] DELETE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.print(attributes)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message || translate('LKMESSAGE-HINT_ERR_TITLE')))

    return rejectWithValue('Failed to delete loan calculation')
  },
)

export const clearLoanCalculation = createAsyncThunk<any, any, ThunkApi>(
  '[LOAN_CALCULATOR] CLEAR',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.loanCalculator.clear(attributes)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message || translate('LKMESSAGE-HINT_ERR_TITLE')))

    return rejectWithValue('Failed to clear loan calculation')
  },
)
